"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  randomKey: true,
  resolveTypeName: true
};
Object.defineProperty(exports, "randomKey", {
  enumerable: true,
  get: function get() {
    return _randomKey.randomKey;
  }
});
Object.defineProperty(exports, "resolveTypeName", {
  enumerable: true,
  get: function get() {
    return _resolveTypeName.resolveTypeName;
  }
});

var _isEmpty = require("./isEmpty");

Object.keys(_isEmpty).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _isEmpty[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _isEmpty[key];
    }
  });
});

var _randomKey = require("./randomKey");

var _resolveTypeName = require("./resolveTypeName");